(() => {
	angular
		.module('main')
		.directive('completeCardDetailsModal', completeCardDetailsModal);

	completeCardDetailsModal.$inject = [];

	function completeCardDetailsModal() {
		return {
			restrict: 'E',
			scope: {},
			template: `
                       <div class="modal modal-center fade modal-card-details" id="cardDetailsModal" tabindex="-1" role="dialog"
                            aria-labelledby="myModalLabel"
                            aria-hidden="true" data-backdrop="static" data-keyboard="false">
                            <div class="dashboard-subscription-modal modal-dialog">
                                <div class="modal-content modal-banner">
                                    <div class="modal-header">
                                        <btn-close ng-click="hideBanner()"></btn-close>
                                         <h3 class="modal-title">Complete your credit card information</h3>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row flex-row flex-wrap-xs">
                                            <div class="col-xs-12 col-sm-4 col-md-3">
                                                <subscription-banner-list></subscription-banner-list>
                                            </div>
                                            <h2 class="col-xs-12 visible-xs-block"></h2>
                    
                                            <div class="col-xs-12 col-sm-8" data-ng-init="init()">
                                               <div class="chosen-subscription-type">
                                                    <subscription-annual
                                                            ng-hide="isAnnualPromoOrDiscountEnabled"
                                                    ></subscription-annual>
                                                    <subscription-annual-promo
                                                            ng-show="isAnnualPromoOrDiscountEnabled"
                                                    ></subscription-annual-promo>
                                                     <subscription-monthly-discount 
                                                           ng-hide="isMonthlyPromoOrDiscountEnabled"
                        							></subscription-monthly-discount>
                                                    <subscription-monthly-promo
                                                            ng-show="isMonthlyPromoOrDiscountEnabled"
                                                    ></subscription-monthly-promo>
                                               </div>
                    
                                                <form role="form" class="mt-30" ng-submit="validateStripe()" ng-show="!userActionResult.success"
                                                      name="stripe">
                                                    <div class="form-group">
                                                        <label>Card Number</label>
                                                        <input type="tel" size="20" class="form-control card-number" maxlength="16"
                                                               autocorrect="off" spellcheck="off" autocomplete="off" autocapitalize="off" required
                                                               placeholder="Enter the number without spaces or hyphens"
                                                               ng-model="card_number">
                                                    </div>
                                                    <label>Expiration (MM/YYYY)</label>
                    
                                                    <div class="form-group">
                                                        <div class="form-inline">
                                                            <input class="form-group form-control card-expiry" maxlength="2"
                                                                   placeholder="MM" size="2" autocomplete="off" type="text" required
                                                                   ng-model="card_expiry_month">
                                                            <input class="form-control card-expiry" type="text" size="4" required
                                                                   placeholder="YYYY" ng-model="card_expiry_year" autocomplete="off" maxlength="4">
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="card_cvc">CW code</label>
                                                        <input type="text" autocomplete="off" class="form-control card-cvc" size="4" maxlength="4" required
                                                               autocomplete="off" placeholder="Enter CW number" ng-model="card_cvc">
                                                    </div>
                    
                                                    <button type="submit" ng-disabled="button_disable" 
                                                            spinning-wheel is-spinning-wheel-active="button_disable"
                                                            class="btn btn-lg btn-rounded btn-success modal-card-details-btn mt-5">
                                                        Subscribe
                                                    </button>
                    
                                                    <button type="button" class="btn btn-lg btn-grey-light modal-card-details-btn mt-5"
                                                            ng-show="user.inTrial || user.expired"
                                                            ng-disabled="button_disable"
                                                            ng-click="choose();hideBanner();">Back
                                                    </button>
                                                </form>
                                            </div>
                    
                                            <h2 class="col-xs-12 visible-xs-block"></h2>
                                            <div class="col-xs-12 col-sm-4">
                                                <div class="modal-banner-feedback">
                                                    <i class="modal-banner-feedback__text">
                                                        <q>Studio Ninja has finally given me the client management system I've been after.
                                                            Every single part of my workflow can be customised <i class="dash"></i> it's
                                                            been a lifesaver.</q>
                                                    </i>
                                                    <figure>
                                                        <img src="https://app.studioninja.co/build/master-59/resources/dist/assets/images/photos/kristen.png" alt="Kristen Cook">
                                                        <figcaption>
                                                            <div class="author">
                                                                Kristen Cook,
                                                            </div>
                                                            <div class="role">
                                                                AIPP Master of Photography
                                                            </div>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                                <div class="modal-banner-feedback">
                                                    <i class="modal-banner-feedback__text">
                                                        <q>Studio Ninja has been a dream to use. A super sleek interface and easy to set
                                                            up.</q>
                                                    </i>
                                                    <figure>
                                                        <img src="https://app.studioninja.co/build/master-59/resources/dist/assets/images/photos/tim.png" alt="Tim Williams">
                                                        <figcaption>
                                                            <div class="author">
                                                                Tim Williams,
                                                            </div>
                                                            <div class="role">
                                                                Photographer
                                                            </div>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                `,
			replace: true,
			transclude: true,
			controller: 'StripeActionsController'
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/Modals/completeCardDetailsModal.js